import {initializeApp} from 'firebase/app'
import {firebaseConfig} from './environment';

export const firebaseApp = initializeApp(firebaseConfig);
